// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3GrRA","content":"RecentSearches_content__1HXHB"};